import { CommonModule, DatePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { InfosInstitucionaisComponent } from '@shared/components/infos-institucionais/infos-institucionais.component'
import { WidgetsModule } from '@widgets/widgets.module'
import { ActionCardComponent } from './components/action-card/action-card.component'
import { CardComponent } from './components/card/card.component'
import { ComunicadoComponent } from './components/comunicado/comunicado.component'
import { DadosBancariosComponent } from './components/dados-bancarios/dados-bancarios.component'
import { DemonstrativoPagamentoResidenteComponent } from './components/demonstrativo-pagamento-residente/demonstrativo-pagamento-residente.component'
import { DistribuicaoBolsasComponent } from './components/distribuicao-bolsas/distribuicao-bolsas.component'
import { EnderecoComponent } from './components/endereco/endereco.component'
import { MunicipioComponent } from './components/endereco/municipio/municipio.component'
import { UfComponent } from './components/endereco/uf/uf.component'
import { FileReviewComponent } from './components/file-review/file-review.component'
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component'
import { FileViewComponent } from './components/file-view/file-view.component'
import { InfoEditalInscricaoComponent } from './components/info-edital-inscricao/info-edital-inscricao.component'
import { InfosCoordenadorComponent } from './components/infos-coordenador/infos-coordenador.component'
import { MatriculadoHeaderComponent } from './components/matriculado-header/matriculado-header.component'
import { ModalConfirmacaoTermosComponent } from './components/modal-confirmacao-termos/component/modal-confirmacao-termos.component'
import { TermosGeraisComponent } from './components/modal-confirmacao-termos/component/termos-gerais/termos-gerais.component'
import { TermosResidenteComponent } from './components/modal-confirmacao-termos/component/termos-residente/termos-residente.component'
import { PickerButtonComponent } from './components/pesquisa-satisfacao/component/satisfacao-picker/picker-button/picker-button.component'
import { SatisfacaoPickerComponent } from './components/pesquisa-satisfacao/component/satisfacao-picker/satisfacao-picker.component'
import { PesquisaSatisfacaoDialogComponent } from './components/pesquisa-satisfacao/dialog/pesquisa-satisfacao-dialog.component'
import { RegistroCardComponent } from './components/registro-card/registro-card.component'
import { ResidenteCardComponent } from './components/residente-card/residente-card.component'
import { ResidenteDadosPessoaisComponent } from './components/residente-dados-pessoais/residente-dados-pessoais.component'
import { ResidenteDetailsComponent } from './components/residente-details/residente-details.component'
import { ResidenteHistoricoSituacoesComponent } from './components/residente-historico-situacoes/residente-historico-situacoes.component'
import { TreeSearchComponent } from './components/tree-search/component/tree-search.component'
import { TreeSearchDialogComponent } from './components/tree-search/dialog/tree-search-dialog.component'
import { VinculoInstituicaoTableComponent } from './components/vinculo-instituicao/vinculo-instituicao-table/vinculo-instituicao-table.component'
import { NoCacheDirective } from './directives/no-cache.directive'
import { CanDeactivateGuard } from './guard/can-deactivate-guard'
import { MultipleFileUploaderComponent } from './components/multiple-file-uploader/multiple-file-uploader.component'
import { FormacaoDuracaoTableComponent } from './components/formacao-duracao/formacao-duracao-table/formacao-duracao-table.component'
import { VinculoTableComponent } from './components/instituicao/vinculo-table/vinculo-table.component'
import { ComissaoTableComponent } from './components/instituicao/comissao-table/comissao-table.component'

@NgModule({
  imports: [CommonModule, WidgetsModule],
  exports: [
    CommonModule,
    WidgetsModule,
    EnderecoComponent,
    UfComponent,
    CardComponent,
    FileUploaderComponent,
    FileReviewComponent,
    FileViewComponent,
    InfoEditalInscricaoComponent,
    InfosInstitucionaisComponent,
    InfosCoordenadorComponent,
    DadosBancariosComponent,
    ComunicadoComponent,
    NoCacheDirective,
    TreeSearchComponent,
    TreeSearchDialogComponent,
    RegistroCardComponent,
    ResidenteHistoricoSituacoesComponent,
    ResidenteDetailsComponent,
    DemonstrativoPagamentoResidenteComponent,
    MatriculadoHeaderComponent,
    ResidenteDadosPessoaisComponent,
    ResidenteCardComponent,
    PesquisaSatisfacaoDialogComponent,
    SatisfacaoPickerComponent,
    DistribuicaoBolsasComponent,
    ActionCardComponent,
    ModalConfirmacaoTermosComponent,
    TermosResidenteComponent,
    TermosGeraisComponent,
    VinculoInstituicaoTableComponent,
    VinculoTableComponent,
    ComissaoTableComponent,
    MultipleFileUploaderComponent,
    FormacaoDuracaoTableComponent,
  ],
  providers: [CanDeactivateGuard, DatePipe],
  declarations: [
    EnderecoComponent,
    MunicipioComponent,
    UfComponent,
    CardComponent,
    FileUploaderComponent,
    FileReviewComponent,
    FileViewComponent,
    InfoEditalInscricaoComponent,
    InfosInstitucionaisComponent,
    DadosBancariosComponent,
    InfosCoordenadorComponent,
    ComunicadoComponent,
    NoCacheDirective,
    TreeSearchComponent,
    TreeSearchDialogComponent,
    RegistroCardComponent,
    ResidenteHistoricoSituacoesComponent,
    ResidenteDetailsComponent,
    DemonstrativoPagamentoResidenteComponent,
    MatriculadoHeaderComponent,
    ResidenteDadosPessoaisComponent,
    ResidenteCardComponent,
    PesquisaSatisfacaoDialogComponent,
    SatisfacaoPickerComponent,
    PickerButtonComponent,
    DistribuicaoBolsasComponent,
    ActionCardComponent,
    ModalConfirmacaoTermosComponent,
    TermosResidenteComponent,
    TermosGeraisComponent,
    VinculoInstituicaoTableComponent,
    VinculoTableComponent,
    ComissaoTableComponent,
    MultipleFileUploaderComponent,
    FormacaoDuracaoTableComponent,
  ],
})
export class SharedModule {}
